import {
	CountryResponse,
	ErpRevenueResponse,
	ErpStatsResponse,
	InterventionTypeSerializable,
	PackMonthDataResponse,
	PriceChangeResponse,
} from 'com.cogvio.pricemonitor.api';
import FullFlags from '../../../UI/CountryIcon/flag-full';
export type CountryCode = keyof typeof FullFlags;

export enum ERPSortBy {
	PRICE = 'price',
	NAME = 'name',
}

export enum ERPDistributionType {
	HOSPITAL = 'hospital',
	RETAIL = 'retail',
}

export enum InterventionTypeList {
	PRICE_CHANGE = 'price-change',
	DELIST = 'delist',
	LAUNCH = 'launch',
}

export const InterventionTypeListTitles: Record<InterventionTypeList, string> = {
	[InterventionTypeList.PRICE_CHANGE]: 'Price intervention',
	[InterventionTypeList.DELIST]: 'Delist',
	[InterventionTypeList.LAUNCH]: 'Launch',
};

export type ERPSpecialStatus = {
	code: string;
	name: string;
};

export type ERPInterventionEditData = {
	countryCode: string;
	type: InterventionTypeSerializable;
	month: string;
	price: {
		value: string;
		currency: string;
	} | null;
};

export type ERPPriceVolumeGrowth = {
	countryCode: string;
	yearlyVolume?: string;
	yoyGrowth?: string;
};

export type MessyRequestBody = { countryCode: string; yearlyVolume?: string; yoyGrowth?: string }[];

export type ERPApiResult = {
	allDataByCountry: {
		[monthDate: string]: PackMonthDataResponse[];
	};
	byMonth: {
		[monthDate: string]: PackMonthDataResponse[];
	};
	byCountry: {
		[countryCode: string]: PackMonthDataResponse & PackMonthDataResponse['country'];
	};
	currency: string;
	erpImpactedCountries: {
		[countryCode: string]: CountryResponse;
	};
	priceChangesByMonth: {
		[monthDate: string]: PriceChangeResponse[];
	};
	sortedDates: string[];
	cumulativeStats: { [countryCode: string]: ErpRevenueResponse };
	stats: ErpStatsResponse;
};
